<div class="list-grid-container"
     [class.has-row-click]="rowActionClick.observers.length > 0 && enableRowPointer"
     *ngIf="config">
  <!-- Title -->
  <div *ngIf="config.title"
       class="title">
    <rappider-heading [content]="config.title.content"
                      [type]="config.title.type"></rappider-heading>
  </div>

  <!-- List actions -->
  <!-- if there is only one list action, display it on the right side of the toolbar, near the column filters -->
  <div *ngIf="config.listActions?.length > 1 || !((config?.filterable !== false) && (config?.columnVisibilitySelectable !== false))"
       class="list-actions"
       [ngStyle]="{'justify-content': rightListActions.length > 1 && !leftListActions.length ?  'flex-end': 'space-between'}">
    <!-- Left list actions -->
    <div *ngIf="leftListActions.length"
         class="left-list-actions">
      <div *ngFor="let action of leftListActions"
           class="left-list-action">
        <!-- Use a dynamic template outlet to choose between dropdown and button, and pass the action context -->
        <ng-container *ngIf="config?.listActionsLength !== 0"
                      [ngTemplateOutlet]="action.behavior === ActionBehavior.DropDownMenu ? dropdownActionTemplate : buttonTemplate"
                      [ngTemplateOutletContext]="{ $implicit: action }">
        </ng-container>
      </div>
    </div>

    <!-- Right list actions -->
    <div *ngIf="rightListActions.length"
         class="right-list-actions">
      <div *ngFor="let action of rightListActions"
           class="right-list-action">
        <!-- Use a dynamic template outlet to choose between dropdown and button, and pass the action context -->
        <ng-container [ngTemplateOutlet]="action.behavior === ActionBehavior.DropDownMenu ? dropdownActionTemplate : buttonTemplate"
                      [ngTemplateOutletContext]="{ $implicit: action }">
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="!config?.hideToolbar"
       class="row grid-toolbar">
    <!-- Search box -->
    <ng-container *ngIf="config.searchable !== false">

      <!-- Standard Search -->
      <div class="col-md-6 col-sm-8 search-area">
        <nz-input-group *ngIf="!config?.showSearchWithAiButton"
                        [nzSuffix]="suffixIconSearch">
          <input *ngIf="!searchButtonActive"
                 type="text"
                 [ngModel]="searchText"
                 (ngModelChange)="filterData($event)"
                 nz-input
                 [placeholder]="config?.searchPlaceholder || 'Type to search'" />
          <input *ngIf="searchButtonActive"
                  type="text"
                  [ngModel]="searchText"
                  (ngModelChange)="updateSearchText($event)"
                  (keypress)="onSearchButtonActiveKeyPress($event)"
                  nz-input
                  [placeholder]="config?.searchPlaceholder || 'Type to search'" />
          <ng-template #suffixIconSearch>
            <ng-container *ngIf="searchText">
              <a *ngIf="searchActive" (click)="filterData(null)">
                <i class="far fa-times-circle"></i>
              </a>
              <a *ngIf="!searchActive" (click)="searchTextEmit(null)">
                <i class="far fa-times-circle"></i>
              </a>
            </ng-container>
          </ng-template>
        </nz-input-group>
        <rappider-button *ngIf="searchButtonActive && searchActive" text="Search" (click)="filterData(searchText)"></rappider-button>
        <rappider-button *ngIf="searchButtonActive && !searchActive" text="Search" (click)="searchTextEmit(searchText)"></rappider-button>

        <!-- AI Search -->
        <div *ngIf="config?.showSearchWithAiButton">
          <textarea #textArea
                    nz-input
                    [disabled]="true"
                    [(ngModel)]="searchAIText"
                    [placeholder]="config?.aiSearchPlaceholder || 'Explain your search, use natural language'"
                    class="ai-search-textarea"
                    [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                    (keypress)="onAISearchKeyPress($event)"></textarea>

          <ng-container *ngIf="searchAIText">
            <a class="ai-search-textarea-clear"
               (click)="searchAIText = undefined">
              <i class="far fa-times-circle"></i>
            </a>
          </ng-container>
        </div>

      </div>

    </ng-container>

    <!-- Visible Columns multi selection - Filter column visibility -->
    <ng-container *ngIf="(config?.filterable !== false) && (config?.columnVisibilitySelectable !== false)">
      <div class="toolbar-actions"
            [ngClass]="{'col-md-12 cols-sm-12': config?.searchable === false, 'col-md-6 col-sm-4': config?.searchable !== false}">
                <!-- Visible Columns multi selection - Filter column visibility -->
              <ng-container *ngIf="(config?.filterable !== false) && (config?.dataVisibilitySelectable !== false) && config?.filterDataByFields?.length">
                  <!-- Column Filters -->
                  <ng-container *ngIf="config?.dataVisibilitySelectable !== false">
                    <nz-select [(ngModel)]="visibleData"
                                class="filter-columns-select"
                                [nzShowSearch]="false"
                                [nzShowArrow]="true"
                                [nzMode]="'multiple'"
                                [nzMaxTagCount]="0"
                                [nzPlaceHolder]="colSelectPlaceHolder"
                                [nzMaxTagPlaceholder]="colSelectPlaceHolder"
                                (ngModelChange)="onDataFilterChange()"
                                (nzOpenChange)="!$event && forceEmitVisibilityColumnsChange()">
                      <nz-option *ngFor="let column of config?.filterDataByFields"
                                [nzDisabled]="config && config.defaultSearchField && column.fieldName === config.defaultSearchField"
                                [nzLabel]="column.title | translate"
                                [nzValue]="column.fieldName"></nz-option>
                    </nz-select>
                    <ng-template #colSelectPlaceHolder
                                let-selectedList>
                      <div class="filter-columns-placeholder">
                        <div>
                          <i class="far fa-line-columns"></i>
                        </div>
                        <div>
                          &nbsp;Filter Category
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
              </ng-container>
        <!-- Column Filters -->
        <ng-container *ngIf="config?.columnVisibilitySelectable !== false">
          <nz-select [(ngModel)]="visibleColumns"
                      class="filter-columns-select"
                      [nzShowSearch]="false"
                      [nzShowArrow]="true"
                      [nzMode]="'multiple'"
                      [nzMaxTagCount]="0"
                      [nzMaxTagPlaceholder]="colSelectPlaceHolder"
                      (ngModelChange)="onFilterChange()"
                      (nzBlur)="forceEmitVisibilityColumnsChange()"
                      (nzOpenChange)="!$event && forceEmitVisibilityColumnsChange()">
            <nz-option *ngFor="let column of getVisibilityChangableColumnList(config?.columns)"
                        [nzDisabled]="config && config.defaultSearchField && column.fieldName === config.defaultSearchField"
                        [nzLabel]="column.title | translate"
                        [nzValue]="column.fieldName"></nz-option>
          </nz-select>
          <ng-template #colSelectPlaceHolder
                        let-selectedList>
            <div class="filter-columns-placeholder">
                <div>
                  <i class="far fa-line-columns"></i>
                </div>
                <div>
                  &nbsp;Filter Columns
                </div>
              </div>
            </ng-template>
          </ng-container>


          <!-- Single Action: IF THERE IS ONLY ONE LIST ACTION, SHOW HERE ON TOOLBAR -->
          <ng-container *ngIf="config?.listActions?.length === 1">
            <div *ngFor="let action of config?.listActions"
                class="left-list-action">
              <!-- Use a dynamic template outlet to choose between dropdown and button, and pass the action context -->
              <ng-container [ngTemplateOutlet]="action.behavior === ActionBehavior.DropDownMenu ? dropdownActionTemplate : buttonTemplate"
                            [ngTemplateOutletContext]="{ $implicit: action }">
              </ng-container>
            </div>
          </ng-container>
          <!-- END OF Single Action -->

        </div>
      </ng-container>

  </div>
  <div *ngIf="config?.overflowList?.items?.length"
      class="overflow-list-wrapper">
  <rappider-overflow-list [items]="config?.overflowList?.items"
                          [minVisibleItems]="config?.overflowList?.minVisibleItems"
                          [collapseFrom]="config?.overflowList?.collapseFrom"
                          [showIcons]="config?.overflowList?.showIcons"
                          [renderCurrentBreadcrumbAsInput]="config?.overflowList?.renderCurrentBreadcrumbAsInput"
                          (itemClick)="onOverflowlistItemClick($event)"></rappider-overflow-list>
  </div>

  <!-- Filter Section Component -->
  <rappider-filter-section [hasActiveFilters]="hasActiveFilters"
                           [appliedFilters]="appliedFilters"
                           [config]="config"
                           (removeFilter)="onRemoveFilter($event)"
                           (clearAllFilters)="clearAllFilters()">
  </rappider-filter-section>



  <nz-table #dataTable
            *ngIf="config.columns?.length"
            nzHideOnSinglePage
            [nzScroll]="{x: config?.scroll?.xAxis, y: config?.scroll?.yAxis}"
            [nzData]="displayedData"
            [nzSize]="config.size"
            [nzShowPagination]="config.showPagination"
            [nzPageSize]="config.pageSize"
            [(nzPageIndex)]="pageNumber"
            [ngClass]="{'no-border': borderless === true, 'loading-state': loading}"
            [nzFrontPagination]="config.nzFrontPagination"
            [nzTotal]="config.nzTotal"
            (nzQueryParams)="onPaginationChange($event)">
    <thead (nzSortOrderChange)="sortData($event)">
      <!-- Column Headers -->
      <tr>
        <!-- Orderable icon -->
        <th *ngIf="config.handleOrderableFn || config.orderable"
            class="table-header order-column-header"></th>
        <!-- Select All checkbox -->
        <th *ngIf="config.selectable"
            nzWidth="62px"
            [nzShowCheckbox]="isMultipleSelectionEnabled()"
            [(nzChecked)]="isAllSelected"
            [nzIndeterminate]="isIndeterminate"
            (nzCheckedChange)="onBulkSelectionChange($event)"
            class="table-header"></th>
        <!-- Columns titles from the config -->
        <ng-container *ngFor="let column of getVisibleColumns(config.columns);let index = index">
          <ng-container *ngIf="(config.sortable === false ? false : column.sortable !== false); else notSortableColumnConfig">
            <th nzShowSort
                [nzColumnKey]="column.fieldName"
                class="table-header"
                [nzLeft]="column?.fixedColumnOnLeft || (config.freezeFirstColumn && index === 0) || false"
                [nzRight]="column?.fixedColumnOnRight || false"
                [nzWidth]="column?.width ? column.width + 'px' : null"
                [ngClass]="(column?.fixedColumnOnRight || column?.fixedColumnOnLeft || (config.freezeFirstColumn && index === 0)) ? 'fixed-header' : null"
                [ngStyle]="getColumnHeaderCellStyles(column)">
              <!-- Filters -->

              <div class="d-flex gap-2">
                <ng-container *ngIf="config.filterable !== false">
                  <div class="filter">
                    <rappider-grid-filter [(ngModel)]="columnFilters[index].filterValue"
                                          [fieldName]="columnFilters[index].fieldName"
                                          [data]="data"
                                          [columnType]="columnFilters[index].columnType"
                                          (dataChange)="onDataFilter($event)"
                                          (ngModelChange)="onFilterValueChange(columnFilters[index].fieldName, $event)"></rappider-grid-filter>
                  </div>
                </ng-container>
                <!-- End of filters -->

                <span [ngStyle]="getColumnHeaderTextStyles(column)">
                  {{ column.title | translate }}
                </span>
              </div>
            </th>
          </ng-container>
          <ng-template #notSortableColumnConfig>
            <th class="table-header"
                [nzWidth]="column?.width ? column.width + 'px' : null"
                [ngStyle]="getColumnHeaderCellStyles(column)">
              <span [ngStyle]="getColumnHeaderTextStyles(column)">
                {{ column.title | translate }}
              </span>
            </th>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="config.itemActions?.length">
          <th class="table-header"
              [nzRight]="config?.fixedActionColumn || false"
              [ngClass]="config?.fixedActionColumn ? 'fixed-header' : null"></th>
        </ng-container>
      </tr>
      <!-- End of Column Headers -->
    </thead>
    <tbody cdkDropList
           (cdkDropListDropped)="onRowOrderChange($event)">
      <tr *ngFor="let data of dataTable.data; let rowIndex = index"
          [id]="data.id"
          [cdkDragDisabled]="!checkListOrderable(displayedData, data) && !config.orderable"
          [ngClass]="getRowClass(data)"
          cdkDrag>
        <!-- Orderable icon -->
        <td *ngIf="config.orderable"
            class="order-column-cell">
          <i class="fas fa-bars"></i>
        </td>
        <!-- HandleOrderable icon -->
        <td *ngIf="config.handleOrderableFn"
            class="order-column-cell">
          <i *ngIf="checkListOrderable(displayedData, data)"
             class="fas fa-bars"></i>
          <i *ngIf="!checkListOrderable(displayedData, data)"
             class="fas fa-bars invisible"></i>
        </td>
        <!-- Select item checkbox -->
        <td *ngIf="config.selectable"
            nzShowCheckbox
            [nzChecked]="data.selected"
            [nzDisabled]="data.disabled"
            (nzCheckedChange)="selectItems($event, rowIndex)"></td>
        <!-- Columns from the config -->
        <td *ngFor="let column of getVisibleColumns(config.columns); let colIndex = index"
            [ngStyle]="getColumnCellStyles(column)"
            [nzLeft]="column?.fixedColumnOnLeft || (config.freezeFirstColumn && colIndex === 0) || false"
            [nzRight]="column?.fixedColumnOnRight || false"
            [ngClass]="(column?.fixedColumnOnRight || column?.fixedColumnOnLeft || (config.freezeFirstColumn && colIndex === 0)) ? 'fixed-column' : null"
            (click)="onRowActionClick(data)">
          <!-- TAG LIST type field -->
          <div *ngIf="column.type === CrudViewColumnType.TagList" class="tag-list-cell">
            <ng-container *ngFor="let tag of getAsArray(getFieldValueByFieldName(data, column.fieldName))">
              <nz-tag *ngIf="tag"
                      [nzColor]="tag?.color || (data?.metadata ? data.metadata.color : undefined) || column?.settings?.color">
                {{ tag?.name || tag }}
              </nz-tag>
            </ng-container>
          </div>
          <!-- OBJECT type field -->
          <ng-container
                        *ngIf="column.type !== CrudViewColumnType.TagList && isListGridDataObject(getFieldValueByFieldName(data, column.fieldName)) && column.isListGridDataObject !== false; else notObjectTemplates">
            <div class="json-field-container">
              <rappider-json-viewer
                [data]="getFieldValueByFieldName(data, column.fieldName)"
                [maxLineToDisplay]="8">
              </rappider-json-viewer>
            </div>
          </ng-container>
          <rappider-input-template *ngIf="column.type === CrudViewColumnType.InputTemplate"
                                   [ngModel]="getFieldValueByFieldName(data, column.fieldName)"
                                   (ngModelChange)="emitFieldValueChange(column, $event, data)"
                                   [typeAndFormat]="{type: column.inputTemplateType}"></rappider-input-template>
          <ng-template #notObjectTemplates>
            <!-- TEXT type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Text">
              <div *ngIf="!showEllipsisTextWithPopover && !data?.icon; else showPrefixIcon"
                   class="ellipsis">
                   {{ getFieldValueByFieldName(data, column.fieldName) | translate }}
              </div>
              <ng-template #showPrefixIcon>
                <div *ngIf="data?.icon; else popoverTemplate">
                  <div class="show-prefix-icon-wrapper">
                    <rappider-icon *ngIf="data?.icon?.name && column?.prefixIconVisible"
                                   [name]="data?.icon?.name"
                                   [color]="data?.icon?.color"
                                   [theme]="data?.icon?.theme"
                                   [type]="data?.icon?.type"
                                   [size]="data?.icon?.size"></rappider-icon>
                    {{ getFieldValueByFieldName(data, column.fieldName) | translate }}
                  </div>
                </div>
              </ng-template>
              <ng-template #popoverTemplate>
                <div class="ellipsis"
                     nz-popover
                     nzPopoverTitle="Value"
                     [nzPopoverContent]="getFieldValueByFieldName(data, column.fieldName)">
                  {{ getFieldValueByFieldName(data, column.fieldName) }}
                </div>
              </ng-template>
            </ng-container>
            <!-- NUMBER type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Number">
              {{ getFieldValueByFieldName(data, column.fieldName) }}
            </ng-container>
            <!-- CURRENCY type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Currency">
              {{ getFieldValueByFieldName(data, column.fieldName) | currency: column.format || 'USD' }}
            </ng-container>
            <!-- TAG type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Tag">
              <!-- get color data from metadata for each row if exist -->
              <nz-tag *ngIf="getFieldValueByFieldName(data,column.fieldName)"
                      [nzColor]="data?.metadata?.color || column?.settings?.color">
                {{ getFieldValueByFieldName(data,column.fieldName) }}</nz-tag>
            </ng-container>

            <!-- ICON type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Icon">
              <!-- <i [ngClass]="getFieldValueByFieldName(data, column.fieldName)"
                 class="icon-column"></i> -->
              <rappider-icon [name]="getFieldValueByFieldName(data, column.fieldName)"></rappider-icon>
            </ng-container>
            <!-- LINK type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Link">
              <a *ngIf="!showEllipsisLinkWithPopover; else popoverTemplate"
                 class="ellipsis column-formatted-link"
                 [routerLink]="execTemplate(column.routerLink, data)"
                 [queryParams]="column.queryParams"
                 [innerHTML]="getFieldValueByFieldName(data, column.fieldName)"
                 [ngStyle]="getColumnLinkTextStyles(column)"
                 [attr.data-column-color]="getColumnTextColorValue(column)"
                 (click)="onLinkCellClicked(column, data)"></a>
              <ng-template #popoverTemplate>
                <a class="ellipsis column-formatted-link"
                   nz-popover
                   nzPopoverTitle="Value"
                   [nzPopoverContent]="getFieldValueByFieldName(data, column.fieldName)"
                   [routerLink]="execTemplate(column.routerLink, data)"
                   [queryParams]="column.queryParams"
                   [innerHTML]="getFieldValueByFieldName(data, column.fieldName)"
                   [ngStyle]="getColumnLinkTextStyles(column)"
                   [attr.data-column-color]="getColumnTextColorValue(column)"></a>
              </ng-template>
            </ng-container>
            <!-- ACTION LINK type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.ActionLink">
              <a class="column-formatted-link"
                 (click)="onEmitItemClick(data)"
                 [ngStyle]="getColumnLinkTextStyles(column)"
                 [attr.data-column-color]="getColumnTextColorValue(column)">{{ getFieldValueByFieldName(data, column.fieldName) }}</a>
            </ng-container>
            <!-- AUTO DATE type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.AutoDate">
              {{ getAutoDateTimeFormat(getFieldValueByFieldName(data, column.fieldName), column?.jsonSchema) ? getAutoDateTimeFormat(getFieldValueByFieldName(data, column.fieldName), column?.jsonSchema) : '-' }}
            </ng-container>
            <!-- DATETIME type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.DateTime">
              {{ getDateTimeFormat(getFieldValueByFieldName(data, column.fieldName)) ? (getFieldValueByFieldName(data, column.fieldName) | date:getDateTimeFormat(getFieldValueByFieldName(data, column.fieldName))) : '-' }}
            </ng-container>
            <!-- DATE type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Date">
              {{convertToDateTime(getFieldValueByFieldName(data, column.fieldName))}}
            </ng-container>
            <!-- BOOLEAN type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Boolean">
              <ng-container *ngIf="getFieldValueByFieldName(data, column.fieldName)">
                <i class="fas fa-check color-green"></i>
              </ng-container>
              <ng-container *ngIf="!getFieldValueByFieldName(data, column.fieldName)">
                <i class="fas fa-times color-red"></i>
              </ng-container>
            </ng-container>
            <!-- IMAGE type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Image">
              <img class="thumbnail"
                   [ngClass]="{ 'no-image-thumbnail': !getFieldValueByFieldName(data, column.fieldName) }"
                   [src]="getFieldValueByFieldName(data, column.fieldName) || noImageUrl" />
            </ng-container>
            <!-- RATE type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Rate">
              <rappider-rate-display [rate]="getFieldValueByFieldName(data, column.fieldName)"></rappider-rate-display>
            </ng-container>
            <!-- JSON type field -->
            <ng-container *ngIf="column.type === CrudViewColumnType.Json">
              <div class="json-field-container">
                <rappider-json-viewer
                  [data]="getFieldValueByFieldName(data, column.fieldName)"
                  [maxLineToDisplay]="10">
                </rappider-json-viewer>
              </div>
            </ng-container>
            <!-- OTHER type field -->
            <ng-container *ngIf="column.type === 'other'">
              {{ getFieldValueByFieldName(data, column.fieldName) }}
            </ng-container>
          </ng-template>
        </td>
        <!-- Action columns -->
        <td *ngIf="config.itemActions?.length"
            class="item-actions"
            [nzRight]="config?.fixedActionColumn || false">
          <ng-container *ngIf="getVisibleActionCount(displayedData, data, config.itemActions) === 1 || (config.itemActionsLength > config.itemActions.length); else dropdownWrap">
            <div class="list-grid-action-buttons-container">
              <ng-container *ngFor="let action of config.itemActions; let itemActionIndex = index">
                <ng-container *ngIf="checkActionButtonVisibility(displayedData, data, action)">
                  <!-- button view -->
                  <ng-container *ngIf="!action.view || action.view === ActionView.Button">
                    <rappider-button [icon]="action.icon"
                                     [iconPlacement]="action?.iconPlacement"
                                     [text]="action.text | translate"
                                     [disabled]="checkActionButtonDisabled(displayedData, data, action) || action.disabled"
                                     [loading]="checkActionButtonLoading(displayedData, data, action) || action.loading"
                                     [type]="action.buttonType"
                                     [size]="action.size || 'extra-small'"
                                     [popconfirmTitle]="action.popconfirmTitle"
                                     [emitWithoutPopconfirm]="action.emitWithoutPopconfirm"
                                     [popconfirmCancelText]="action.popconfirmCancelText"
                                     [popconfirmOkText]="action.popconfirmOkText"
                                     [popconfirmOkDanger]="action.popconfirmOkDanger"
                                     [popconfirmPlacement]="action.popconfirmPlacement"
                                     [tooltipText]="checkActionButtonTooltip(displayedData, data, action) || action.tooltipText"
                                     [redirectUrl]="action?.redirectUrl"
                                     [redirectTarget]="action?.redirectTarget"
                                     (confirm)="onColumnActionClick(action, data, rowIndex)">
                    </rappider-button>
                  </ng-container>

                  <!-- icon view -->
                  <ng-container
                                *ngIf="action.view === ActionView.Icon && action.behavior !== ActionBehavior.DropDownMenu && action.popconfirmTitle">
                    <a (click)="onColumnActionClick(action, data, rowIndex)">
                      <ng-container *ngIf="action.icon">
                        <i [ngClass]="action.icon"></i>
                      </ng-container>
                    </a>
                  </ng-container>

                  <!-- icon view drop down menu -->
                  <ng-container
                                *ngIf="action.view === ActionView.Icon && action.behavior === ActionBehavior.DropDownMenu">
                    <a nz-dropdown
                       nzPlacement="leftTop"
                       nzTrigger="click"
                       [nzDropdownMenu]="menu">
                      <ng-container *ngIf="action.icon">
                        <i [ngClass]="action.icon"></i>
                      </ng-container>
                      <span *ngIf="action.text">{{ action.text | translate}}</span>
                    </a>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>
                        <li *ngFor="let menuItem of action.actions"
                            nz-menu-item
                            [nzDisabled]="menuItem.disabled"
                            class="action-drop-down-menu-item"
                            (click)="onColumnActionClick(menuItem, data, rowIndex)">
                          <ng-container *ngIf="menuItem.icon">
                            <i [ngClass]="menuItem.icon"></i>
                          </ng-container>
                          &nbsp;&nbsp;
                          <span *ngIf="menuItem.title">{{ menuItem.title }}</span>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </ng-container>
                  <nz-divider *ngIf="config.itemActions.length > (itemActionIndex + 1)"
                              nzType="vertical"></nz-divider>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>

          <ng-template #dropdownWrap>
            <a *ngIf="checkItemActionDropdownMenuVisiblity(displayedData, data, config.itemActions)"
               nz-dropdown
               nzPlacement="leftTop"
               nzTrigger="click"
               [nzDropdownMenu]="menu">
              <i nz-icon
                 nzType="ellipsis"
                 nzTheme="outline"></i>
            </a>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <ng-container *ngFor="let action of config.itemActions; let itemActionIndex = index">

                  <ng-container *ngIf="checkActionButtonVisibility(displayedData, data, action)">
                    <li *ngIf="action.popconfirmTitle"
                        class="action-drop-down-menu-item"
                        nz-menu-item
                        nz-popconfirm
                        [nzDisabled]="action.disabled"
                        [nzPopconfirmTitle]="action.popconfirmTitle | translate"
                        [nzCancelText]="action.popconfirmCancelText| translate"
                        [nzOkText]="action.popconfirmOkText| translate"
                        [nzOkDanger]="action.popconfirmOkDanger"
                        (nzOnCancel)="cancel()"
                        (nzOnConfirm)="onColumnActionClick(action, data, rowIndex)">
                      <div class="action-drop-down-menu-item-row">
                        <div class="dropdown-menu-item-icon">
                          <i *ngIf="action.icon" [ngClass]="action.icon"></i>
                          <rappider-icon *ngIf="action.icon"
                                        [name]="action.icon.name"
                                        [type]="action.icon.type"
                                        [color]="action.icon.color"
                                        [theme]="action.icon.theme"
                                        [size]="action.icon.size"></rappider-icon>
                        </div>
                        <div *ngIf="action.text"
                             class="dropdown-menu-item-text">
                          <span>{{ action.text | translate }}</span>
                        </div>
                      </div>
                    </li>
                    <li *ngIf="!action.popconfirmTitle"
                        class="action-drop-down-menu-item"
                        nz-menu-item
                        [nzDisabled]="action.disabled"
                        (click)="onColumnActionClick(action, data, rowIndex)">
                      <div class="action-drop-down-menu-item-row">
                        <div class="dropdown-menu-item-icon">
                          <i *ngIf="action.icon" [ngClass]="action.icon"></i>
                          <rappider-icon *ngIf="action.icon"
                                        [name]="action.icon.name"
                                        [type]="action.icon.type"
                                        [color]="action.icon.color"
                                        [theme]="action.icon.theme"
                                        [size]="action.icon.size"></rappider-icon>
                        </div>
                        <div *ngIf="action.text"
                             class="dropdown-menu-item-text">
                          <span>{{ action.text | translate }}</span>
                        </div>
                      </div>
                    </li>
                  </ng-container>
                </ng-container>
              </ul>
            </nz-dropdown-menu>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div *ngIf="loading"
       class="loading">
    <span nz-icon
          nzType="loading"
          nzTheme="outline"></span>
    <span> {{loadingMessage | translate}}</span>
  </div>
</div>


<!-- Reusable template for Dropdown Menu Action -->
<ng-template #dropdownActionTemplate
             let-action>
  <ng-container *ngIf="customDropdownTemplate; else configDropdownTemplate">
    <ng-container *ngTemplateOutlet="customDropdownTemplate"></ng-container>
  </ng-container>
  <ng-template #configDropdownTemplate>
    <button nz-button
            nz-dropdown
            [attr.id]="action?.id"
            [nzDropdownMenu]="menu">
      <span *ngIf="action.icon">
        <rappider-icon [name]="action.icon.name"
                       [type]="action.icon.type"></rappider-icon>
        &nbsp;
      </span>
      {{ action.text | translate }}
    </button>

    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <ng-container
                      *ngTemplateOutlet="recursiveMenuList; context:{ $implicit: action?.dropdownConfig?.items }"></ng-container>
        <ng-template #recursiveMenuList
                     let-menus>
          <ng-container *ngFor="let menu of menus">
            <div class="menu-item">
              <div class="menu-item-icon">
                <rappider-icon *ngIf="menu.icon && menu.icon?.name"
                               [name]="menu.icon.name"
                               [color]="menu.icon.color"
                               [theme]="menu.icon.theme"
                               [type]="menu.icon.type"
                               [size]="menu.icon.size"></rappider-icon>
              </div>
              <li *ngIf="menu.items?.length; else menuItem"
                  nz-submenu
                  [nzTitle]="menu.label | translate"
                  (click)="onListActionDropdownItemClick(menu)">
                <ul>
                  <ng-container *ngTemplateOutlet="recursiveMenuList; context:{ $implicit: menu.items }"></ng-container>
                </ul>
              </li>
              <ng-template #menuItem>
                <li *ngIf="!menu.popconfirmTitle; else popConfirmTitleTemplate"
                    nz-menu-item
                    (click)="onListActionDropdownItemClick(menu)"> {{ menu.label | translate }}
                </li>
                <ng-template #popConfirmTitleTemplate>
                  <li nz-menu-item
                      nz-popconfirm
                      [nzPopconfirmTitle]="menu.popconfirmTitle | translate"
                      [nzOkText]="menu.label| translate"
                      [nzOkDanger]="menu.popconfirmOkDanger"
                      (nzOnConfirm)="onListActionDropdownItemClick(menu)"> {{ menu.label | translate }} </li>
                </ng-template>
              </ng-template>
            </div>
          </ng-container>
        </ng-template>
      </ul>
    </nz-dropdown-menu>
  </ng-template>
</ng-template>


<!-- Reusable template for Button Action -->
<ng-template #buttonTemplate
             let-action>
  <rappider-button [icon]="action.icon"
                   [iconPlacement]="action?.iconPlacement"
                   [text]="action.text | translate"
                   [disabled]="action.disabled"
                   [ngClass]="action.cssClass"
                   [type]="action.buttonType"
                   [popconfirmTitle]="action.popconfirmTitle"
                   [emitWithoutPopconfirm]="action.emitWithoutPopconfirm"
                   [popconfirmCancelText]="action.popconfirmCancelText"
                   [popconfirmOkText]="action.popconfirmOkText"
                   [popconfirmOkDanger]="action.popconfirmOkDanger"
                   [popconfirmPlacement]="action.popconfirmPlacement"
                   [tooltipText]="action?.tooltipText"
                   [redirectUrl]="action?.redirectUrl"
                   [redirectTarget]="action?.redirectTarget"
                   (confirm)="onListActionClick(action)">
  </rappider-button>
</ng-template>
